import useSwr from "@/core/composables/swr/useSwr";
import {dosageApi} from "@/container";
import {DosageTimeTrigger} from "@/dosage/interfaces/Dosage";

/**
 * SWR composable to fetch dosage time triggers.
 */
const useDosageTimeTrigger = () => {
    return useSwr<DosageTimeTrigger[]>("dosages/time-triggers", () => {
        return dosageApi().indexTimeTrigger();
    });
};

export default useDosageTimeTrigger;
